import { getFielderSession } from 'FielderUtils/session/Session';
import { pipe } from 'lodash/fp';

import API_LINKS from '../apiGateWayLinks';
import { get, requestHandler } from '../request';

// Get export count
export const getExportBranchCount = async (params, onSuccess, onError) => {
	const path = API_LINKS.exportBranches;

	const queryParams = new URLSearchParams(params);

	const doRequest = pipe(get, requestHandler(onSuccess, onError));
	return doRequest(path, null, queryParams.toString(), {});
};

// Get export task data
export const getExportBranchList = async (body, onSuccess, onError) => {
	const path = API_LINKS.exportBranches;

	const queryParams = new URLSearchParams(body);

	const doRequest = pipe(get, requestHandler(onSuccess, onError));
	return doRequest(path, null, queryParams.toString(), {});
};
